import React, { ChangeEvent, CSSProperties } from "react";

interface TextInputProps {
  label?: string;
  name?: string;
  value?: any;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  Component?: string;
  maxLength?: number;
  required?: boolean;
  className?: string;
  style?: CSSProperties;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  value,
  onChange,
  error = "",
  touched = false,
  disabled = false,
  Component = "",
  maxLength,
  required = false,
  className = "",
  style = {},
}) => (
  <div className={`mb-0 ${className}`} style={style}>
    <div className="form-floating">
      <input
        type="text"
        className={`form-control ${touched && error ? "is-invalid" : ""}`}
        id={`txt${Component}${name}`}
        name={name}
        value={value}
        onChange={onChange}
        placeholder=" "
        disabled={disabled}
        maxLength={maxLength}
      />
      <label htmlFor={`txt${Component}${name}`}>
        {label}
        {!disabled && required && <span style={{ color: "red" }}>*</span>}
      </label>
      {touched && error && <div className="invalid-feedback">{error}</div>}
    </div>
  </div>
);

export default TextInput;
